import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
// import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import { DatePicker, DateTimePicker } from '@material-ui/pickers';
import moment from '../../helpers/dates';
import DateIcon from '../../assets/DateIcon';
import InputBase from '../InputBase';

const DateInput = ({
  id, format, value, handleChange, disabled, minDate, maxDate,
  timePicker, timeFormat, error, helperText, defaultCalendarMonth, ...other
}) => {
  const [currentValue, setCurrentValue] = useState(value);
  const theme = useTheme();

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const getFormattedDate = (rawDate) => (timePicker
    ? moment(rawDate).format(`${format} ${timeFormat === '12h' ? 'hh:mmA' : 'HH:mm'}`)
    : moment(rawDate).format(format));

  const CustomInput = ({
    error: errorProp, helperText: helperTextProp, ...otherProps
  }) => (
    <InputBase
      id={id}
      error={error}
      helperText={helperText}
      autoComplete="off"
      {...otherProps}
      {...other}
      value={otherProps.value ? otherProps.value : ''}
      endAdornment={(
        <InputAdornment position="end">
          <IconButton
            disableRipple
            size="small"
            color="primary"
          >
            <DateIcon />
          </IconButton>
        </InputAdornment>
       )}
    />
  );

  CustomInput.propTypes = {
    helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  };

  CustomInput.defaultProps = {
    helperText: undefined,
    error: undefined,
  };

  const defaultValue = defaultCalendarMonth ? moment(defaultCalendarMonth) : value;
  const dateProps = {
    // clearable: true,
    onChange: setCurrentValue,
    value: value ? moment(value) : defaultValue,
    minDate: minDate ? moment(minDate) : undefined,
    maxDate: maxDate ? moment(maxDate) : undefined,
    onAccept: (val) => handleChange(val ? val.format(timePicker ? 'YYYY-MM-DD[T]HH:mm:ss' : 'YYYY-MM-DD') : ''),
    TextFieldComponent: CustomInput,
    labelFunc: () => (currentValue ? getFormattedDate(currentValue) : ''),
    okLabel: <span style={{ color: theme.palette.secondary.main }}>OK</span>,
    cancelLabel: <span style={{ color: theme.palette.secondary.main }}>CANCEL</span>,
    clearLabel: <span style={{ color: theme.palette.secondary.main }}>CLEAR</span>,
  };

  return (
    <>
      {timePicker ? (
        <DateTimePicker ampm={timeFormat === '12h'} disabled={disabled} {...dateProps} />
      ) : (
        <DatePicker disabled={disabled} {...dateProps} />
      )}
    </>
  );
};

DateInput.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  format: PropTypes.string,
  timeFormat: PropTypes.string,
  value: PropTypes.string.isRequired,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  timePicker: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  helperText: PropTypes.string,
  error: PropTypes.string,
  defaultCalendarMonth: PropTypes.string,
};

DateInput.defaultProps = {
  disabled: false,
  timePicker: false,
  minDate: undefined,
  maxDate: undefined,
  format: 'LL',
  timeFormat: '24h',
  helperText: undefined,
  error: undefined,
  defaultCalendarMonth: undefined,
};

export default DateInput;
